import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  lotID: {
    description: 'It is an abbreviation of the series number to which the product belongs',
    defaultMessage: '({quantity}) — Lot: {lot}',
    id: 'q4yze3',
  },
  multipleLots: {
    description: 'Expandable header that shows/hides the lot list when clicked',
    defaultMessage: 'Multiple Lots',
    id: 'DBoR1P',
  },
  lotUnavailable: {
    description: 'Lot number is not available',
    defaultMessage: 'N/A',
    id: 'jzxHHg',
  },
});
